import React from 'react';
import PropTypes from 'prop-types';
import './RotatorScroll.scss';

/**
 * RotatorScroll component
 * @desc Takes a sprite image with the width and height to generate a rotating image component on scroll
 * @note: Use http://www.retinaspritegenerator.com/ to generate left-to-right sprite
 * @note: Use https://tinypng.com/ to compress created sprite
 * @param {Number} width @required
 * @param {Number} height @required
 * @param {String} image @required
 * @returns {React.Component}
 */

/**
 * Optional now
 * You can pass in a sequential grouping of images defined by their url string and start/end numbers
 * <RotatorScroll width={1920} height={900} imagePath="http://path/img0000.png" imgStart={0} imgEnd={131}/>
 * This will load all images like img0000.png, img00001.png, imgNNNN.png, up to img0131.png
 * Note: URL must be publicly accessible, can't use require('img/path/item.jpg');
 */

const propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    image: PropTypes.string,
}

export default class RotatorScroll extends React.Component {
    constructor (props) {
        super(props);

        let currentImage = this.props.image ? this.props.image : this.props.imagePath;

        this.state = {
            currentImage: currentImage,
            imgLeft: 0,
            imageNumber: 0,
            zoom: 1,
            marginLeft: 0
        };

        this.imgStyle = {
            width: `${this.props.width}px`,
            height: `${this.props.height}px`
        };

        this.begin = null;
        this.stopAnimating = false;
    }

    componentDidMount () {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.calculateImage);
    }

    calculateImage = () => {
        this.imgWidth = this.refs.rotatorImage.clientWidth;

        if(this.props.image) {
            this.frames = (this.imgWidth / this.props.width) - 1; // index at 0
        } else {
            this.frames = this.props.imgEnd;
        }

        let zoom = this.refs.rotatorContainer.parentElement.clientWidth / this.props.width;
        let marginLeft = 0;
        // For tablet + mobile screen sizes
        let clientWidth = this.refs.rotatorContainer.clientWidth;
        if(window.innerWidth <= 1024) {
            zoom = this.refs.rotatorContainer.nextElementSibling.height / this.refs.rotatorContainer.querySelector('img').height;
            // This determines how much margin should be created to center the image in the viewport on mobile
            marginLeft = (clientWidth - (this.props.width - clientWidth))/clientWidth * 100;
            // Reset if less than 0;
            marginLeft = marginLeft < 0 ? 0 : marginLeft;
        }
        if(window.innerWidth < 769) {
            let clientHeight = this.refs.rotatorContainer.getBoundingClientRect().height;
            marginLeft = -(1-(clientWidth/clientHeight)+.1) * 100;
            // No margin if greater than 0
            marginLeft = marginLeft > 0 ? 0 : marginLeft;
        }
        if(zoom < 1) {
            this.setState({zoom, marginLeft});
        } else {
            this.setState({zoom: 1});
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.calculateImage);
    }

    handleScroll = () => {
        // Allow image to time to load and calculate
        if(!this.frames) {
            return;
        }

        if(this.stopAnimating) {
            return;
        }

        // We need to make sure it finishes by before it starts to cross back into the top
        let top = this.refs.rotatorImage.getBoundingClientRect().top - (this.props.height / 1.5);

        // We add a 25% margin based on image height
        if(top < window.innerHeight / 4 ){//&& bottom > 0) {
            // Set our initial begin section
            if(!this.begin) {
                this.begin = top;
            }

            let frame = 0;
            if(top < 0) {
                frame = parseInt( Math.abs(top) / (this.props.height / 2 / this.frames) );
            }

            // Don't let it go past last frame
            if(frame > this.frames) {
                if(this.props.stopAnimating) {
                    this.stopAnimating = true;
                }
                return;
            }

            if(frame < 0) {
                frame = 0;
            }

            let imgLeft = 0;
            if(this.props.image) {
                imgLeft = frame * this.props.width;
                this.setState({imgLeft})
            }

            // If having to use individual files, this is better to use, but will slow down image loading :(
            if(this.props.imagePath) {
                let tempImg = this.props.imagePath.split('.');
                let frameCharCount = frame.toString().length;
                let imgNameStripped = tempImg[0].substr(0, tempImg[0].length - frameCharCount);
                let imgSrc = `${imgNameStripped}${frame}.${tempImg[1]}`;

                this.setState({
                    currentImage: imgSrc
                })
            }
        }
    }

    // Use transform for GPU acceleration
    render () {
        return (
            <div ref="rotatorContainer" className="rotator-container" style={this.imgStyle}>
                <div style={{ width: `0px`, transform: `scale(${this.state.zoom})`, marginLeft: `${this.state.marginLeft}%`}}>
                    <img onLoad={this.calculateImage} ref="rotatorImage" src={ this.state.currentImage } style={{transform: `translate3d(-${this.state.imgLeft}px, 0, 0)`}}/>
                </div>
            </div>

        );
    }
}

RotatorScroll.propTypes = propTypes;





// WEBPACK FOOTER //
// ./src/components/RotatorScroll/index.js